import { css } from '@emotion/core';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const SourceCodeBlock = css({
  borderTop: `1px solid ${token('color.border', colors.N50)}`,
  borderBottom: 'none',
});

export const SourceCodeLine = css({
  backgroundColor: token('elevation.surface', colors.N0),
  fontFamily: token('font.family.code'),
  padding: `${token('space.025')} ${token('space.100')}`,
  verticalAlign: 'top',
});

export const SourceCodeText = css({
  whiteSpace: 'pre',
  wordWrap: 'normal',
});
